import React, { useState } from 'react';
import '../styles/Contact.css';

function Contact() {
  const initialState = {
    name: '',
    email: '',
    company: '',
    country: '',
    service: '',
    message: ''
  };

  const [formData, setFormData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage('');

    const data = new FormData();
    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });

    try {
      const response = await fetch('/sendmail.php', {
        method: 'POST',
        body: data
      });

      const result = await response.json();

      if (result.status === 'success') {

        // ✅ CLEAR FORM HERE
        setFormData(initialState);

        setResponseMessage(
          '✅ Thank you! Your inquiry has been sent successfully. We will contact you within 24 hours.'
        );

      } else {
        setResponseMessage('❌ Error sending message. Please try again later.');
      }

    } catch (error) {
      setResponseMessage('❌ Error sending message. Please try again later.');
    }

    setLoading(false);
  };

  return (
    <div className="contact">
      <section className="page-header">
        <div className="header-particles">
          <div className="particle particle-1">📧</div>
          <div className="particle particle-2">🌍</div>
          <div className="particle particle-3">💬</div>
          <div className="particle particle-4">📞</div>
          <div className="particle particle-5">✉️</div>
        </div>
        <div className="container">
          <h1>Contact Us</h1>
          <p>Let's discuss how we can help transform your business</p>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-grid">
            <div className="contact-info">
              <h2>Get In Touch</h2>
              <p>
                Ready to start your AI and cloud transformation journey? Fill out the form 
                and our team will reach out within 24 hours to schedule a free consultation.
              </p>

              <div className="contact-details">
                <div className="contact-item">
                  <div className="contact-icon">📧</div>
                  <div>
                    <h4>Email</h4>
                    <p>admin-support@sevensolutionsai.com</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">🌍</div>
                  <div>
                    <h4>Serving Globally</h4>
                    <p>INDIA | US | UK | Middle East</p>
                  </div>
                </div>

                <div className="contact-item">
                  <div className="contact-icon">⏰</div>
                  <div>
                    <h4>Response Time</h4>
                    <p>Within 24 hours</p>
                  </div>
                </div>
              </div>

              <div className="why-contact">
                <h3>What Happens Next?</h3>
                <ul>
                  <li>We'll review your requirements</li>
                  <li>Schedule a free 30-minute consultation call</li>
                  <li>Discuss your specific needs and challenges</li>
                  <li>Provide initial recommendations and next steps</li>
                  <li>Share a tailored proposal if there's a good fit</li>
                </ul>
              </div>
            </div>

            <div className="contact-form-wrapper">
              <form className="contact-form" onSubmit={handleSubmit}>
                
                <div className="form-group">
                  <label htmlFor="name">Full Name *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="John Doe"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email Address *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    placeholder="john@company.com"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="company">Company Name *</label>
                  <input
                    type="text"
                    id="company"
                    name="company"
                    value={formData.company}
                    onChange={handleChange}
                    required
                    placeholder="Your Company"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="country">Country / Region *</label>
                  <select
                    id="country"
                    name="country"
                    value={formData.country}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select your country</option>
                    <option value="US">United States</option>
                    <option value="UK">United Kingdom</option>
                    <option value="AE">United Arab Emirates</option>
                    <option value="SA">Saudi Arabia</option>
                    <option value="AU">Australia</option>
                    <option value="Other">Other</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="service">Service Interest *</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    required
                  >
                    <option value="">Select a service</option>
                    <option value="ai-workflow">AI Workflow Automation</option>
                    <option value="cloud-devops">Cloud & DevOps Setup</option>
                    <option value="ai-strategy">AI Strategy Consulting</option>
                    <option value="multiple">Multiple Services</option>
                    <option value="not-sure">Not Sure Yet</option>
                  </select>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Tell Us About Your Project *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    placeholder="Describe your business challenges..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-full"
                  disabled={loading}
                >
                  {loading ? 'Sending...' : 'Send Message'}
                </button>

                {responseMessage && (
                  <p style={{ marginTop: '15px', fontWeight: '500' }}>
                    {responseMessage}
                  </p>
                )}

                <p className="form-note">
                  By submitting this form, you agree to receive communications from us.
                  We respect your privacy and will never share your information.
                </p>

              </form>
            </div>
          </div>
        </div>
      </section>

      <section className="map-section">
        <div className="container">
          <h2>Our Global Presence</h2>
          <p>Serving SMEs across four continents with local expertise and global best practices</p>
          <div className="regions-map">
            <div className="region-badge">India</div>
            <div className="region-badge">United States</div>
            <div className="region-badge">United Kingdom</div>
            <div className="region-badge">Middle East</div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;